// A receipt number, a reservation message and the Standart marker "PA" are
// not order numbers. Prefer the public number over an internal database ID.
export const couponOrderNumber = (response: any): string => {
  const result = response?.result;
  const candidates = [
    response?.order_number,
    result?.order_number,
    response?.order_id,
    result?.order_id,
    result?.id,
    typeof result === 'string' && /^PA\d+[A-Za-z0-9_-]*$/.test(result)
      ? result
      : '',
  ];
  const supplied = candidates
    .map((value) =>
      typeof value === 'string' || typeof value === 'number'
        ? String(value).trim()
        : ''
    )
    .filter((value) => value && value !== 'PA');
  return (
    supplied.find((value) => /^PA\d+[A-Za-z0-9_-]*$/.test(value)) ||
    supplied[0] ||
    ''
  );
};
